<template>
    <div class="grid-content">
        <div class="grid-item grid-item-full">
            <template v-if="hasCredentialHash">
                <v-radio
                    :group="selectionGroup"
                    :value="true"
                    class="stack-m"
                    :model="useExistingCredentials"
                    caption="Enable to use previously saved credentials for this email."
                    @update="useExisting"
                    label="Use Existing Credentials"/>
                <v-radio
                    :group="selectionGroup"
                    label="Advanced Settings"
                    caption="Enable advanced settings to define your own SMTP or email service provider."
                    :value="false"
                    :model="useExistingCredentials"
                    @update="useAdvanced"/>
            </template>
            <v-checkbox
                v-else
                label="Advanced Settings"
                caption="Enable advanced settings to define your own SMTP or email service provider."
                :value="true"
                v-model="showAdvanced"/>
        </div>
        <div v-if="showAdvanced" class="grid-item grid-item-full">
            <r-tabs
                :divided="true"
                @tab-selected="selectTab"
                menu-class="no-margin-bottom"
                class="stack-m">
                <r-tab
                    v-for="(tab, tabIndex) in credentialTabs"
                    :key="tabIndex"
                    :name="tab.name"
                    :value="tab.value">
                    <component
                        v-bind="tab.bind"
                        :email="email"
                        :validationAggregator="validationAggregator"
                        :active-type="activeType"
                        @input="updateCredentials"/>
                </r-tab>
            </r-tabs>
            <div class="divider"></div>
        </div>
    </div>
</template>

<script>
    import {vCheckbox, vRadio} from '@/components/form';
    import EmailCredentialModel from '@/common/models/email-credential-model';
    import shortid from 'shortid';
    import SMTP from './smtp';
    import Mailgun from './mailgun';
    import SendGrid from './send-grid';
    import AWSSES from './aws-ses';
    import Postmark from './postmark';

    export default {
        components: {
            vCheckbox, vRadio,
        },
        name: 'advanced-settings',
        props: {
            /**
             * @type {EmailModel|{}}
             */
            email: Object,
            validationAggregator: Object,
        },
        computed: {
            hasCredentialHash() {
                // TODO assert effectiveness here when updating a rule
                return this.email.credentialHash !== null;
            },
        },
        data() {
            return {
                selectionGroup: shortid.generate(),
                showAdvanced: this.email.$credentials !== null,
                useExistingCredentials: true,
                credentialTabs: [
                    {
                        name: 'SMTP',
                        value: EmailCredentialModel.Types.smtp,
                        bind: {
                            is: SMTP,
                            type: EmailCredentialModel.Types.smtp,
                        },
                    },
                    {
                        name: 'Mailgun',
                        value: EmailCredentialModel.Types.mailgun,
                        bind: {
                            is: Mailgun,
                            type: EmailCredentialModel.Types.mailgun,
                        },
                    },
                    {
                        name: 'SendGrid',
                        value: EmailCredentialModel.Types.sendGrid,
                        bind: {
                            is: SendGrid,
                            type: EmailCredentialModel.Types.sendGrid,
                        },
                    },
                    {
                        name: 'AWS SES',
                        value: EmailCredentialModel.Types.awsSES,
                        bind: {
                            is: AWSSES,
                            type: EmailCredentialModel.Types.awsSES,
                        },
                    },
                    {
                        name: 'Postmark',
                        value: EmailCredentialModel.Types.postmark,
                        bind: {
                            is: Postmark,
                            type: EmailCredentialModel.Types.postmark,
                        },
                    },
                ],
                activeType: EmailCredentialModel.Types.smtp,
            };
        },
        methods: {
            selectTab({value}) {
                this.activeType = value;
            },
            useExisting() {
                this.showAdvanced = false;
                this.useExistingCredentials = true;
                // remove previously saved credentials in the email
                this.$emit('input', null);
            },
            useAdvanced() {
                this.showAdvanced = true;
                this.useExistingCredentials = false;
                // save default credentials for the current email
                this.$emit('input', new EmailCredentialModel());
            },
            updateCredentials(credentials) {
                this.$emit('input', credentials);
            },
        },
    };
</script>
